import { SwingIndex as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { limitMoveValue } = options;
    const T = limitMoveValue || 99999;

    if (data.length < 2) {
      return [];
    }

    const results = [];

    // First bar is always undefined (needs previous bar)
    results.push(undefined);

    for (let i = 1; i < data.length; i++) {
      const current = data[i];
      const previous = data[i - 1];

      if (!current || !previous) {
        results.push(undefined);
        continue;
      }

      // Check for required OHLC data
      if (
        current.high === undefined ||
        current.low === undefined ||
        current.close === undefined ||
        current.open === undefined ||
        previous.close === undefined ||
        previous.open === undefined
      ) {
        results.push(undefined);
        continue;
      }

      // Calculate Swing Index components
      const A = Math.abs(current.high - previous.close);
      const B = Math.abs(current.low - previous.close);
      const C = Math.abs(current.high - current.low);
      const D = Math.abs(previous.close - previous.open);
      const K = Math.max(A, B);
      const M = Math.max(C, K);

      // Calculate R with conditional adjustments
      let R = M + 0.25 * D;
      if (M === A) {
        R -= 0.5 * B;
      } else if (M === B) {
        R -= 0.5 * A;
      }

      // Calculate Swing Index
      let swing = 0;
      if (R !== 0 && T !== 0) {
        const numerator =
          current.close -
          previous.close +
          0.5 * (current.close - current.open) +
          0.25 * (previous.close - previous.open);
        swing = ((50 * numerator) / R) * (K / T);
      }

      // For Swing Index (not Accumulative), we return the swing value directly
      results.push(swing);
    }

    return results;
  }

  calculator.undefinedLength = function () {
    return 1; // First bar is undefined
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
